import Experience from "./Experience/Experience";
import Main from "./Main";
import AboutMe from "./aboutme/AboutMe";
import Marquee from "./marquee/Marquee";
import Footer from "./footer/Footer";
export default function App() {
  return (
    <html>
      <body className="bg-[#0A0A0A]">
        <div className="xl:w-8/12 lg:w-10/12 md:w-11/12 m-auto">
          <Main />
          <Marquee />
          <AboutMe />
          <Experience />
          <Footer />
        </div>
      </body>
    </html>
  );
}
